import { Autocomplete, Checkbox, TextField } from '@biq/apex-ui';
import { Controller } from 'react-hook-form';
import { Grid, InputAdornment, ListItem, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { walletsAndGroupsCommonStyles } from 'pages/wallets-and-groups/wallets-and-groups-helper';
import { GroupMembersData } from './create-or-edit-user-group-helper';
import { autoCompleteStyles } from '../../../../lib';

interface AutoCompleteGroupMembersFieldProps {
    name: string;
    label: string;
    control: any;
    options: GroupMembersData[];
    fieldValue: GroupMembersData[];
    error: any;
}

export const CustomRenderOption = ({ props, option, selected }: any): any => (
    <ListItem {...props}>
        <Grid display={'flex'} flexDirection={'row'}>
            <Checkbox checked={selected} />
            <Grid display={'flex'} flexDirection={'column'}>
                <Typography
                    sx={walletsAndGroupsCommonStyles.checkboxHeaderStyles}
                >
                    {option.header}
                </Typography>
                <Typography
                    sx={walletsAndGroupsCommonStyles.checkboxSubtitleStyles}
                >
                    {option.subtitle}
                </Typography>
            </Grid>
        </Grid>
    </ListItem>
);

export const AutoCompleteGroupMembersField = ({
    name,
    label,
    control,
    options,
    fieldValue,
    error,
}: AutoCompleteGroupMembersFieldProps): React.JSX.Element => {
    const getOptionLabel = (option: any): any => {
        const foundOption = options.find((opt: any) => opt?.id === option.id);
        return foundOption ? foundOption.value : '';
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }): React.JSX.Element => (
                <Autocomplete
                    {...field}
                    options={options}
                    sx={autoCompleteStyles}
                    disableCloseOnSelect
                    getOptionLabel={getOptionLabel}
                    onChange={(__, newValue): any => {
                        field.onChange(newValue);
                    }}
                    value={fieldValue}
                    renderOption={(props, option, { selected }): any => (
                        <CustomRenderOption
                            props={props}
                            option={option}
                            selected={selected}
                        />
                    )}
                    multiple={true}
                    renderInput={(params): React.JSX.Element => (
                        <TextField
                            {...params}
                            size='medium'
                            label={label}
                            variant='outlined'
                            required
                            error={!!error}
                            errorText={error ? error.message : ''}
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: [
                                    <InputAdornment
                                        key={'searchIcon'}
                                        position='start'
                                    >
                                        <SearchIcon />
                                    </InputAdornment>,
                                    params.InputProps.startAdornment
                                        ? params.InputProps.startAdornment
                                        : [],
                                ],
                            }}
                        />
                    )}
                />
            )}
        />
    );
};
